import React, { memo, forwardRef } from "react";
import anim from "../../../../utils/anim";
import { motion } from "framer-motion";
import { BsGiftFill } from "react-icons/bs";
import { BlurOverlay } from "../../../CoreUI";

import "./brand-overlay.css";
import "../../SendDialog/send-dialog.css";
import accessibilityProvider from "../../../../utils/accessibilityProvider";

const BrandOverlay = memo(
	forwardRef(({ brandName = "", discount = "", handleClose }, ref) => {
		return (
			<BlurOverlay className="brand-overlay-container">
				<motion.div
					className="brand-overlay-icon"
					variants={anim.dialogItem}
				>
					<BsGiftFill />
				</motion.div>
				<motion.div
					className="brand-overlay-title"
					variants={anim.dialogItem}
				>
					{brandName}
				</motion.div>
				<motion.div
					className="brand-overlay-body"
					variants={anim.dialogItem}
				>
					<div className="brand-overlay-body-text">{discount}</div>
				</motion.div>
				<motion.button
					type="button"
					onClick={() => handleClose(false)}
					variants={anim.dialogItem}
					className="btn brand-overlay-btn"
					id="brand-overlay-close-btn"
					{...accessibilityProvider({
						name: `Hide ${brandName} Offer`,
					})}
					ref={ref}
				>
					Hide
				</motion.button>
			</BlurOverlay>
		);
	})
);

export default BrandOverlay;
